// COMPONENT IMPORTS
import { apiInstance } from "store/api/axiosApi";
import {
  CREATE_CARD,
  CREATE_STAX_PROFILE,
  CREATE_WALLETS_PROFILE,
  DELETE_DEFAULT_CARD,
  GET_CARD_DETAILS,
  GET_COUNTRY_LIST,
  GET_OLD_PAYMENT_METHODS,
} from "store/api/constApi";
import { withSlug } from "utils/currentSlug";

/* ------------------------------------- PAYMENT METHOD SERVICES ------------------------------------- */

export const getOldPaymentMethodsData =  (params: any) => {
  return apiInstance.get(GET_OLD_PAYMENT_METHODS, { params });
};

export const deleteOrDefaultCard = (payload: any) => {
  return apiInstance.post(DELETE_DEFAULT_CARD, payload);
};

export const createCard =  (payload: any) => {
  return apiInstance.post(CREATE_CARD, withSlug(payload));
};

export const getCountryList = () => {
  return apiInstance.get(GET_COUNTRY_LIST, { params: withSlug() });
};

export const createWalletsProfile = (payload: any) => {
  return apiInstance.post(CREATE_WALLETS_PROFILE, withSlug(payload));
};

export const createStaxProfile = (payload: any) => {
  return apiInstance.post(CREATE_STAX_PROFILE, withSlug(payload));
}

export const getCardDetails = (params: any) => {
  return apiInstance.get(GET_CARD_DETAILS, { params });
};
